















import { Component, Prop, Vue } from "vue-property-decorator";

import ListItem from "@/components/common/list/ListItem.vue";
import ListItemRow from "@/components/common/list/ListItemRow.vue";
import ServiceMenuStatusIcon from "@/components/service-status/ServiceMenuStatusIcon.vue";
import { ServiceMenuStatusIconType } from "@/consts/const";
import { ServiceMenuEventInterface } from "@/interfaces/service-menu-event.interface";

@Component({
  components: { ServiceMenuStatusIcon, ListItem, ListItemRow },
})
export default class EventListItem extends Vue {
  private ServiceMenuStatusIconType = ServiceMenuStatusIconType;
  @Prop({ required: true }) event!: ServiceMenuEventInterface;

  private onClick(): void {
    this.$emit("click", this.event);
  }
}
